import React, { useEffect, useState } from 'react'
import { Box, Button } from '@mui/material'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../common/snippets'
import DropDownOA from '../../../common/dropDownOA'
import UserMasterTable from './UserMasterTable'
import { connect } from 'react-redux'
import { updateModal } from '../../../../store/common/common_action';
import CreateNewUser from './CreateNewUser'
import { focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { statusOpt } from "../constants"
import { getAllBranchName, getAllDriverConductor, getRollRights } from '../../../../store/branchAndUserMaster/BUMAction'
import { PostRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import { useAtom } from 'jotai'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../../common/jotaiState/globalStateAtoms'

const UserMaster = (props) => {
    const { data, getAllBranchName, getAllDriverConductor, getRollRights,loginData } = props
    const { common } = data
    const [showTable, setShowTable] = useState(false)
    const [status, setStatus] = useState({ name: 'Active', id: 1 })
    const [branchData, setBranchData] = useState([])
    const [rollRightData, setRollRightData] = useState([])
    const [tableData, setTableData] = useState([])
    const [, setLoader] = useAtom(globalLoaderAtom)
    const [, setAlert] = useAtom(alertAtom)
    const [modal, setModal] = useAtom(modalAtom)
    useEffect(() => {
        focusElemnt("UMStatus")
    }, [])
    useEffect(() => {
        if (loginData?.intCompanyID !== 'undefined') {
            getBranchData()
            getRollRightsData()
            if(loginData.intCompanyID){
                onLoad()
            }
        }
    }, [loginData?.intCompanyID])
    const getBranchData = () => {
        const obj = {
            intUserID: loginData?.intUserID,
            intCompanyID: loginData?.intCompanyID,
            intBranchID: 0,
            strBranchName: '',
            strBranchCode: '',
            intStateID: 0,
            intCityID: 0,
            intIsActive: 1,
        }
        getAllBranchName(obj, true, 24 * 60 * 60 * 1000).then((res) => {
            if (res?.status == 'Success') {
                if (res?.Data?.Table?.length > 0) {
                    setBranchData(res?.Data?.Table || [])
                } else {
                    setBranchData(res?.Data?.Table || [])
                }
            } else {
                setModal();
                setAlert({ show: true, msg: res.Message, nextId: 'GSBConsignment_Type' })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    const getRollRightsData = () => {
        const obj = {
            CompanyID: loginData?.intCompanyID,
            RoleID: 0,
            IsActive: 1,
        }
        getRollRights(obj, true, 24 * 60 * 60 * 1000).then((res) => {
            if (res?.status == 'Success') {
                if (res?.Data?.Table?.length > 0) {
                    setRollRightData(res?.Data?.Table || [])
                } else {
                    setRollRightData(res?.Data?.Table || [])
                }
            } else {
                setAlert({ show: true, msg: res.ErrMessage })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    const CreateNewUserModal = () => {
        return <CreateNewUser onLoad={onLoad}  rollRightData={rollRightData} isEdit={false} branchData={branchData || []} loginData={loginData} />
    }
    const onLoad = async () => {
      setLoader(true)
      const body = {
        intUserID: 0,
        intCompanyID: loginData.intCompanyID,
        intBranchID: 0,
        strUserName: '',
        strLoginID: '',
        strPassword: '',
        strContactNo: '',
        intRoleID: 0,
        intIsActive: status?.id,
      }
      try {
        const res = await PostRequest(urls.getUserMasterTableData, body)
        if (res.status === 'Success') {
          setTableData(res?.Data?.Table || [])
        } else {
          setAlert({ show: true, msg: res.ErrMessage })
        }
      } catch (error) {
        console.log('Error:', error)
      } finally {
        setLoader(false)
        setShowTable(true)
      }
    }
    return (
        <>
            <Box sx={sx.reportFlex} className='reportButton'>
                <Item sx={sx.itemsx} style={{ width: "250px" }}>
                    {/* <DropDownOA
                        id="UMCompanyName"
                        label={'Company Name'}
                        width="100%"
                        // dataKey={`SubType`}
                        // idKey={`ConsignmentSubTypeID`}
                        nextId={"UMStatus"}
                        prevId={"UMCreateNewMaster"}
                    /> */}
                    <DropDownOA
                        id="UMCompanyName"
                        label={'Company Name'}
                        defaultvalue={loginData.strCompanyName}
                        disabled={true}
                        // onSelect={(val) => { setSelCompany(val); setShowTable(false) }}
                        width="100%"
                    />
                </Item>
                <Item sx={sx.itemsx} style={{ width: "250px" }}>
                    {/* <DropDownOA
                        id="UMStatus"
                        label={'Status'}
                        width="100%"
                        nextId={"UMLoad"}
                        prevId={"UMCompanyName"}
                    /> */}
                    <DropDownOA
                        id={"UMStatus"}
                        defaultvalue={status?.name || ""}
                        data={[{ name: "Show All", id: -1 }, ...statusOpt] || []}
                        width="100%"
                        noCross={true}
                        searchPlaceholder={`Search Status`}
                        label={"Status"}
                        dataKey={`name`}
                        idKey={`id`}
                        nextId={"UMLoad"}
                        prevId={"UMCreateNewMaster"}
                        onSelect={(value) => setStatus(value)}
                    />
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMCreateNewMaster", "UMStatus", () => { })}>
                    <Button id="UMLoad" variant="contained" style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary"
                        onClick={onLoad}
                    >
                        LOAD
                    </Button>
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMStatus", "UMLoad", () => { })}>
                    <Button id="UMCreateNewMaster" variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={() => setModal( "CreateNewUser")}>
                        CREATE NEW USER
                    </Button>
                </Item>
            </Box>
            <Box sx={sx.reportFlex}>
                {(showTable ) && <UserMasterTable tableData={tableData} status={status} rollRightData={rollRightData}  branchData={branchData || []} onLoad={onLoad} loginData={loginData}/>}

            </Box>
            {modal === "CreateNewUser" && CreateNewUserModal()}
        </>
    )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal, getAllBranchName, getAllDriverConductor,getRollRights
}
export default connect(mapStateToProps, mapDispatchToProps)(UserMaster)
